import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        <div className="navbar__logo" onClick={() => scrollToSection('hero')}>
          <img src={process.env.PUBLIC_URL + '/logochurros.png'} alt="Churros ATX" />
          <span className="navbar__brand">Churros ATX</span>
        </div>
        <button 
          className={`navbar__hamburger ${menuOpen ? 'active' : ''}`} 
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
          <li onClick={() => scrollToSection('about')}>About</li>
          <li onClick={() => scrollToSection('menu')}>Menu</li>
          <li onClick={() => scrollToSection('favorites')}>Favorites</li>
          <li onClick={() => scrollToSection('gallery')}>Gallery</li>
          <li onClick={() => scrollToSection('catering')}>Catering</li>
          <li onClick={() => scrollToSection('contact')}>Contact</li>
          <li>
            <button className="navbar__cta" onClick={() => scrollToSection('catering')}>
              Book Catering
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
